/*
 * @Description: 转专业表格数据
 * @Author: lisenlin
 * @Date: 2021-08-27 09:41:19
 * @LastEditors: lisenlin
 * @LastEditTime: 2021-08-27 17:48:44
 */
import React, { useState } from 'react'
import { Table, Button } from 'antd'
import css from '../index.css'
import NHFetch from '../../../utils/NHFetch';

export default function StaticTable(props) {
    const [type, setType] = useState('xy');  //当前查看类别 学院还是专业
    const [xyid, setXyid] = useState('');     //当前的学院id
    const [record, setRecord] = useState({});
    const list = props.staticTableXylistData;
    let { zyList = [], queryTableZylistData } = props

    /** 点击学院名称 */
    const clickBm = (record) => {
        if (type === 'xy') {
            setType('zy');
            setXyid(record.PKID)
            setRecord(record)
            queryTableZylistData(record.PKID)
        }
    }
    const clickExport = () => {
        let gridUrl = `/proData/gridList/excel/params`;
        let exportUrl = `/proData/gridList/excel/export`;
        let columnsMap
        let params, excelName
        if (type === 'zy') {
            params = {
                filters: {},
                initParams: {},
                pagination: {},
                searchParams: {},
                searchTextMap: {},
                sign: "zhxg_yxxt_zytz_zy_excel",
                sorter: {},
                sqlParams: { bmid: xyid }
            }
            excelName = `${record.BMMC}` + "专业统计结果"
            columnsMap = { "ROW_ID": '序号', "ZYMC": "专业名称" }
        } else {
            params = {
                filters: {},
                initParams: {},
                pagination: {},
                searchParams: {},
                searchTextMap: {},
                sign: "zhxg_yxxt_zytz_bm",
                sorter: {},
                sqlParams: {}
            }
            excelName = '全校院系统计结果'
            columnsMap = { "ROW_ID": '序号', "BMMC": "学院名称" }
        }
        Object.assign(columnsMap, { "TOTAL": "录取人数", 'ZRCS': '转入人数', 'ZCCS': '转出人数', 'JZRRS': '净转入人数', 'TZHTOTAL': '实际人数' })
        NHFetch(gridUrl, "POST", { params: params, columnsMap: columnsMap, excelName: excelName })
            .then(res => {
                if (res) {
                    if (!res.data) {
                        message.info("请刷新浏览器，重新再执行此操作！");
                        return;
                    }
                    window.open(baseUrl + exportUrl + "?uuid=" + res.data, "_blank");
                }
                stopLoading();
            }).catch(err => stopLoading());
    }

    const columns = [
        {
            title: '序号',
            dataIndex: 'ROW_ID',
            key: 'ROW_ID',
            width: ''
        },
        {
            title: type === 'zy' ? '专业名称' : '学院名称',
            dataIndex: type === 'zy' ? 'ZYMC' : 'BMMC',
            key: type === 'zy' ? 'ZYMC' : 'BMMC',
            render: (text, record) => {
                if (type === 'zy') {
                    return text
                }
                return (
                    <a onClick={() => { clickBm(record) }}>{text}</a>
                )
            }
        },
        {
            title: '录取人数',
            dataIndex: 'TOTAL',
            key: 'TOTAL',
        },
        {
            title: '转入人数',
            dataIndex: 'ZRCS',
            key: 'ZRCS',
        },
        {
            title: '转出人数',
            dataIndex: 'ZCCS',
            key: 'ZCCS',
        },
        {
            title: '净转入人数',
            dataIndex: 'JZRRS',
            key: 'JZRRS',
        },
        {
            title: '实际人数',
            dataIndex: 'TZHTOTAL',
            key: 'TZHTOTAL',
        },
    ]
    return (
        <div className={css.cardWarp}>
            <div className={css.warpRight}>
                {
                    type === 'zy' &&
                    <Button type="default" onClick={() => { setType('xy'); setXyid(null) }} style={{ marginRight: '10px' }}>返回</Button>
                }
                <Button type={"primary"} onClick={() => clickExport()}>导出</Button>
            </div>
            <Table
                rowKey="PKID"
                columns={columns}
                // bordered={true}
                dataSource={type === 'zy' ? zyList : list}
                size="middle"
                pagination={false}
            />
        </div>
    )
}



// WEBPACK FOOTER //
// ./components/changeMajorStaic/staticTable/index.js